export default __webpack_public_path__ + "static/media/bottom_mobile_banner_SimplyCLICK.75cf09b6.png";